<template>
  <report
    :title="$t('language.officialvisitsummary')"
    :filter="filter"
    :url="url"
  >
    <template v-slot:filter>
      <v-flex xs12 sm12 md3>
        <ValidationProvider
          :name="$t('language.attendanceyear')"
          rules="required"
          v-slot="{ errors }"
        >
          <v-autocomplete
            dense
            v-model="filter.attendanceyearid"
            :items="AttendanceYearList"
            item-text="name"
            item-value="id"
            :label="$t('language.attendanceyear')"
            :error-messages="errors[0]"
            :clearable="true"
          ></v-autocomplete>
        </ValidationProvider>
      </v-flex>
      <v-flex xs12 sm12 md3>
        <v-autocomplete
          dense
          v-model="filter.officialvisitid"
          :items="OfficialVisitList"
          item-text="name"
          item-value="id"
          :label="$t('language.officialvisit')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.personid"
          :items="PersonList"
          item-text="name"
          item-value="id"
          :label="$t('language.person')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.branchid"
          :items="BranchList"
          item-text="name"
          item-value="id"
          :label="$t('language.branch')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.departmentid"
          :items="DepartmentList"
          item-text="name"
          item-value="id"
          :label="$t('language.department')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.designationid"
          :items="DesignationList"
          item-text="name"
          item-value="id"
          :label="$t('language.designation')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.modeid"
          :items="ModeList"
          item-text="name"
          item-value="id"
          :label="$t('language.mode')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
    </template>
    <template v-slot:printheader>
      <table class="w-100">
        <tbody>
          <tr>
            <td>
              {{ $t("language.attendanceyear") }}:{{ selectedattendanceyear }}
            </td>
            <td></td>
            <td>
              {{ $t("language.officialvisit") }}:{{ selectedofficialvisit }}
            </td>
            <td></td>
            <td>{{ $t("language.person") }}:{{ selectedperson }}</td>
            <td></td>
            <td>{{ $t("language.branch") }}:{{ selectedbranch }}</td>
            <td></td>
            <td>{{ $t("language.department") }}:{{ selecteddepartment }}</td>
            <td></td>
            <td>{{ $t("language.designation") }}:{{ selecteddesignation }}</td>
            <td></td>
            <td>{{ $t("language.mode") }}:{{ selectedmode }}</td>
          </tr>
        </tbody>
      </table>
    </template>
    <template v-slot:table="{ data }">
      <table class="table table-bordered w-100">
        <thead>
          <tr>
            <th>{{ $t("language.person") }}</th>
            <th>{{ $t("language.designation") }}</th>
            <th>{{ $t("language.officialvisit") }}</th>
            <th>{{ $t("language.taken") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data" :key="index">
            <td>{{ item.person }}</td>
            <td>{{ item.designation }}</td>
            <td>{{ item.officialvisit }}</td>
            <td>{{ item.taken }}</td>
          </tr>
        </tbody>
        <tfoot v-if="data.length == 0">
          <tr>
            <th colspan="4">{{ $t("language.nodatafound") }}</th>
          </tr>
        </tfoot>
      </table>
    </template>
  </report>
</template>
<script>
import axios from "axios";
import moment from "moment";
import Report from "../Report";
import commonservice from "../../../../shared/common.service";
export default {
  components: {
    Report,
  },
  data() {
    return {
      filter: {
        attendanceyearid: null,
        officialvisitid: null,
        personid: null,
        branchid: null,
        departmentid: null,
        designationid: null,
        modeid: null,
      },
      AttendanceYearList: [],
      OfficialVisitList: [],
      PersonList: [],
      BranchList: [],
      DepartmentList: [],
      DesignationList: [],
      ModeList: [],
      url: "client/report/officialvisit/summaries",
    };
  },
  computed: {
    selectedattendanceyear() {
      if (this.filter.attendanceyearid == null) return this.$t("language.all");
      return this.AttendanceYearList.filter((c) => {
        return c.id == this.filter.attendanceyearid;
      })[0].name;
    },
    selectedofficialvisit() {
      if (this.filter.officialvisitid == null) return this.$t("language.all");
      return this.OfficialVisitList.filter((c) => {
        return c.id == this.filter.officialvisitid;
      })[0].name;
    },
    selectedperson() {
      if (this.filter.personid == null) return this.$t("language.all");
      return this.PersonList.filter((c) => {
        return c.id == this.filter.personid;
      })[0].name;
    },
    selectedbranch() {
      if (this.filter.branchid == null) return this.$t("language.all");
      return this.BranchList.filter((c) => {
        return c.id == this.filter.branchid;
      })[0].name;
    },
    selecteddepartment() {
      if (this.filter.departmentid == null) return this.$t("language.all");
      return this.DepartmentList.filter((c) => {
        return c.id == this.filter.departmentid;
      })[0].name;
    },
    selecteddesignation() {
      if (this.filter.designationid == null) return this.$t("language.all");
      return this.DesignationList.filter((c) => {
        return c.id == this.filter.designationid;
      })[0].name;
    },
    selectedmode() {
      if (this.filter.modeid == null) return this.$t("language.all");
      return this.ModeList.filter((c) => {
        return c.id == this.filter.modeid;
      })[0].name;
    },
  },
  beforeRouteEnter(to, from, next) {
    axios.get("client/report/officialvisit/init/list").then((response) => {
      next((p) => {
        p.DepartmentList = response.data.departments;
        p.BranchList = response.data.branches;
        p.DesignationList = response.data.designations;
        p.ModeList = response.data.modes;
        p.AttendanceYearList = response.data.attendanceyears;
        p.OfficialVisitList = response.data.officialvisits;
        p.PersonList = response.data.persons;
        let currendate = new Date();
        let current = p.AttendanceYearList.find(item=> new Date(item.startdate) <= currendate && new Date(item.enddate) >= currendate);
        if(current != null)
          p.filter.attendanceyearid = current.id;
      });
    });
  },
};
</script>
